<template>
  <div class="content">
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>{{ isAudit?'审批详情':disabled? '查看资料' :txt }}</span>
      <el-tag v-if="$route.query.isAudit" class="approve-tag" :type="type[approveState]" size="small" >{{ approveStateObj[approveState] }}</el-tag>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <!-- start of 基础信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公司名称" prop="tenantGuid">
                <el-select
                  v-model="ruleForm.tenantGuid"
                  :disabled="disabled || !!$route.query.guid"
                  placeholder="请选择"
                  filterable
                  class="w300"
                  @change="tenantChange"
                >
                  <el-option
                    v-for="item in tenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="ruleForm.terminalProperty == '连锁门店' ? '分店名称' : '药店名称'"
                prop="customerName"
              >
                <el-input
                  v-model="ruleForm.customerName"
                  class="w300"
                  placeholder="请输入"
                  @blur="checkCommonCustomer(ruleForm.customerName)"
                  :disabled="disabled"
                  :maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="标注位置" prop="markers">
                <div class="map-a-sty" v-if="!ruleForm.markers && !disabled" @click="showMap">
                  <i class="el-icon-plus"></i> 选择地图
                </div>
                <div v-if="ruleForm.markers && !disabled" class="map-a-sty" @click="showMap">
                  <i class="el-icon-plus"></i> 重新选择
                </div>
                <div v-if="ruleForm.markers && ruleForm.markers.lat">
                  经度：{{ ruleForm.markers.lng || '' }}，纬度：{{ ruleForm.markers.lat || '' }}
                </div>
                <div v-else-if="disabled">-</div>
                <div v-if="!disabled" class="fontC-4fa1a4">提示：请确认定位准确，以免影响客户拜访定位</div>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="详细地址" prop="address">
                <el-input
                  type="textarea"
                  v-model="ruleForm.address"
                  :disabled="disabled"
                  class="w300"
                  placeholder="请输入"
                  :maxlength="100"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="药店类型" prop="terminalProperty">
                <el-select v-model="ruleForm.terminalProperty" @change="changeTerminalProperty" :disabled="disabled" placeholder="请选择" class="w300">
                  <el-option v-for="item in customerTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 连锁总部 -->
            <el-col
              :span="12"
              v-show="
                getFieldConfig('chainHeadquartesName', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁门店'
              "
            >
              <el-form-item
                :label="getFieldConfig('chainHeadquartesName', 'fieldAlias')"
                prop="customerLevelOption"
                :required="false"
              >
              <el-input
               @focus="openMedDialog" 
               type="text" 
               :disabled="disabled"
               class="w300"
               v-model="ruleForm.chainHeadquartesName" 
               clearable
               :placeholder="getFieldConfig('chainHeadquartesName', 'tipText')"
               ></el-input>
              <!-- 运营端都是非必填 :required="getFieldConfig('chainHeadquartesName', 'isRequired') == 'Y' ? true : false"-->
                <!-- <el-select
                  v-model="ruleForm.chainHeadquartesGuid"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('chainHeadquartesName', 'tipText')"
                  class="w300"
                  filterable
                  remote
                  :remote-method="getChainHeadquartes"
                  @change="changeChainHeadquartesName"
                >
                  <el-option
                    v-for="item in chainHeadquartesOption"
                    :key="item.commonGuid"
                    :label="item.customerName"
                    :value="item.commonGuid"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属区域" prop="addressList">
                <el-cascader
                  ref="cascaderFirst"
                  v-model="ruleForm.addressList"
                  :disabled="disabled"
                  :options="options"
                  class="w300"
                  @change="incres"
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-show="ruleForm.terminalProperty == '连锁总部'">
              <el-form-item label="直营门店数量">
                <el-input-number
                  v-model="ruleForm.directStoresNum"
                  :disabled="disabled"
                  :min="0"
                  :max="1000000"
                  label="请输入"
                ></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-show="ruleForm.terminalProperty == '连锁总部'">
              <el-form-item label="加盟门店数量">
                <el-input-number
                  v-model="ruleForm.affiliatedShopNum"
                  :disabled="disabled"
                  :min="0"
                  :max="1000000"
                  label="请输入"
                ></el-input-number>
              </el-form-item>
            </el-col>

            <!-- 连锁总部类型 -->
            <el-col
              :span="12"
              v-show="
                getFieldConfig('chainHeadquartersType', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'
              "
            >
              <el-form-item
                :label="getFieldConfig('chainHeadquartersType', 'fieldAlias')"
                :required="getFieldConfig('chainHeadquartersType', 'isRequired') == 'Y' ? true : false"
              >
                <el-select
                  v-model="ruleForm.chainHeadquartersType"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('chainHeadquartersType', 'tipText')"
                  class="w300"
                  filterable
                >
                  <el-option
                    v-for="item in transform(getFieldConfig('chainHeadquartersType', 'selectItemList'))"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 备案名称 -->
            <el-col :span="12" v-show="getFieldConfig('recordName', 'formVisible') == 'Y'">
              <el-form-item
                :label="getFieldConfig('recordName', 'fieldAlias')"
                :required="getFieldConfig('recordName', 'isRequired') == 'Y' ? true : false"
              >
                <el-input
                  v-model="ruleForm.recordName"
                  :disabled="disabled"
                  class="w300"
                  :placeholder="getFieldConfig('recordName', 'tipText')"
                  :maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 客户等级 -->
            <el-col :span="12" v-show="getFieldConfig('level', 'formVisible') == 'Y'">
              <el-form-item
                :label="getFieldConfig('level', 'fieldAlias')"
                :required="getFieldConfig('level', 'isRequired') == 'Y' ? true : false"
              >
                <el-select
                  v-model="ruleForm.level"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('level', 'tipText')"
                  class="w300"
                  :required="getFieldConfig('level', 'isRequired') == 'Y' ? true : false"
                  filterable
                >
                  <el-option
                    v-for="item in transform(getFieldConfig('level', 'selectItemList'))"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="启用状态">
                <el-radio-group class="w300" :disabled="disabled" v-model="ruleForm.bizState">
                  <el-radio label="Y">启用</el-radio>
                  <el-radio label="S">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col> -->
            <el-col :span="12" v-show="ruleForm.terminalProperty !== '连锁总部'">
              <el-form-item label="经营时长(年)" prop="manageDuration">
                <el-input-number
                  v-model="ruleForm.manageDuration"
                  :disabled="disabled"
                  :min="0"
                  :max="1000000"
                  label="请输入"
                ></el-input-number>
                <!-- <el-input v-model="ruleForm.manageDuration" type="number" class="w300" placeholder="请输入" :maxlength="5" clearable></el-input> -->
              </el-form-item>
            </el-col>

            <el-col :span="12" v-show="ruleForm.terminalProperty !== '连锁总部'">
              <el-form-item label="面积(m²)" prop="areaMeasure">
                <el-input-number
                  v-model="ruleForm.areaMeasure"
                  :disabled="disabled"
                  :min="0"
                  :max="1000000"
                  label="请输入"
                ></el-input-number>
                <!-- <el-input v-model="ruleForm.areaMeasure" type="number" class="w300" placeholder="请输入" :maxlength="10" clearable></el-input> -->
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              v-show="getFieldConfig('establishDate', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'"
            >
              <!-- 成立时间 -->
              <el-form-item
                :label="getFieldConfig('establishDate', 'fieldAlias')"
                :required="getFieldConfig('establishDate', 'isRequired') == 'Y' ? true : false"
              >
                <el-col :span="11">
                  <el-form-item prop="establishDate">
                    <el-date-picker
                      type="date"
                      :placeholder="getFieldConfig('establishDate', 'tipText')"
                      v-model="ruleForm.establishDate"
                      :disabled="disabled"
                      class="w300"
                      :picker-options="expireTimeOption"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              v-show="
                getFieldConfig('enterpriseNature', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'
              "
            >
              <!-- 企业性质 -->
              <el-form-item
                :label="getFieldConfig('enterpriseNature', 'fieldAlias')"
                :required="getFieldConfig('enterpriseNature', 'isRequired') == 'Y' ? true : false"
              >
                <el-select
                  v-model="ruleForm.enterpriseNature"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('enterpriseNature', 'tipText')"
                  class="w300"
                  filterable
                >
                  <el-option
                    v-for="item in transform(getFieldConfig('enterpriseNature', 'selectItemList'))"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              v-show="getFieldConfig('industryStatus', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'"
            >
              <!-- 行业地位 -->
              <el-form-item
                :label="getFieldConfig('industryStatus', 'fieldAlias')"
                :required="getFieldConfig('industryStatus', 'isRequired') == 'Y' ? true : false"
              >
                <el-select
                  v-model="ruleForm.industryStatus"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('industryStatus', 'tipText')"
                  class="w300"
                  filterable
                >
                  <el-option
                    v-for="item in transform(getFieldConfig('industryStatus', 'selectItemList'))"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col
              :span="12"
              v-show="getFieldConfig('lawsuit', 'formVisible') == 'Y' && ruleForm.terminalProperty == '连锁总部'"
            >
              <!-- 司法官司 -->
              <el-form-item
                :label="getFieldConfig('lawsuit', 'fieldAlias')"
                :required="getFieldConfig('lawsuit', 'isRequired') == 'Y' ? true : false"
              >
                <el-select
                  v-model="ruleForm.lawsuit"
                  :disabled="disabled"
                  :placeholder="getFieldConfig('lawsuit', 'tipText')"
                  class="w300"
                  filterable
                >
                  <el-option
                    v-for="item in transform(getFieldConfig('lawsuit', 'selectItemList'))"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </div>
      </div>
      <!-- end of 基础信息 -->

      <!-- start of 联系人信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系人信息</span>
        <div class="form-item-box">
          <el-row>
            <el-col :span="12">
              <el-form-item label="药店联系人" prop="contacts">
                <el-input
                  ref="contactsRef"
                  @input="ruleForm.contacts = ruleForm.contacts.replace(/[^\a-\z\A-\Z\u4E00-\u9FA5]/g, '')"

                  @blur="checkName('contacts', ruleForm.contacts, ruleForm)"
                  :disabled="disabled"
                  v-model="ruleForm.contacts"
                  class="w300"
                  placeholder="请输入"
                  :maxlength="10"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="手机号码">
                <el-input
                  @input="ruleForm.contactTel = ruleForm.contactTel.replace(/[^\d\-\d]/g, '')"
                  v-model="ruleForm.contactTel"
                  :disabled="disabled"
                  class="w300"
                  maxlength="13"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="建档时间" required>
                <el-col :span="11">
                  <el-form-item prop="inputDate">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="ruleForm.inputDate"
                      :disabled="disabled"
                      class="w300"
                      :picker-options="expireTimeOption"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="业务指派人员">
                <div class="addPeople" v-if="!disabled" @click="popupBox()"><i class="el-icon-plus"></i> 添加人员</div>
                <!-- 人员表格 -->
                <ChoosePerson
                  ref="choosePerson"
                  :showChoosePerson.sync="showChoosePerson"
                  :areaData="areaData"
                  :serviceTenants="serviceTenants"
                  :serviceTenantGuid="serviceTenantGuid"
                  :dialogLoading="dialogLoading"
                  :list="belongStaffList"
                  @getPerson="getPerson"
                >
                </ChoosePerson>
                <!-- 人员表格 -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系人信息 -->

      <!-- 按钮区域 -->
      <div class="operte-btns back-color-fff" v-if="!isAudit">
        <div class="btn cancel" @click="back()">取消</div>
        <div class="btn submit" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 2)">提交</div>
        <div class="btn submit" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 2)">提交</div>
        <div class="btn submit" v-if="txt == '添加资料'" @click="submitForm('ruleForm', 1)">添加下一个</div>
        <!-- <div class="btn submit" v-if="txt != '添加资料'" @click="upDateForm('ruleForm', 1)">添加下一个</div> -->
      </div>
      <div class="operte-btns back-color-fff" v-else>
        <el-button v-if="approveState=='A'" type="primary" size="small"  @click="toAudit()">审核</el-button>
        <el-button v-if="approveState=='Y'||approveState=='N'" type="primary" size="small"  @click="toAudit()">撤回重审</el-button>
        <el-button type="defalut" size="small"  @click="$router.go(-1)">返回</el-button>
      </div>
    </el-form>

    <!-- 弹框部分 -->
    <el-dialog title="选择地图" :visible.sync="dialogVisible" width="980px">
      <dialogMap ref="refMap" :markers="ruleForm.markers" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog>
    <!-- <el-dialog title="选择地图" :visible.sync="dialogVisible" width="80%">
      <dialogMap ref="refMap" @getMarkers="getMarkers" @close="close"></dialogMap>
    </el-dialog> -->
    <!-- 重复客户 -->
    <el-dialog title="相似客户" :visible.sync="customerSameDialog" width="1200px">
      <img width="168" src="../../assets/images/repeat_customer.png" alt="" />
      <div class="same-tip">该客户已存在</div>
      <el-table :data="commonCustomerList" style="width: 100%" row-key="guid" border class="mt15">
        <el-table-column prop="customerName" label="客户名称" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="terminalProperty"
          label="客户属性"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="venue" label="所在区域" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          label="业务代表"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="mobileNo" label="业务代表电话" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="$router.go(-1)">退出建档</el-button>
        <el-button size="medium" type="info" @click="customerSameDialog = false">返回修改</el-button>
      </div>
    </el-dialog>
    <!-- 选择连锁总部开始 -->
    <el-dialog class="med-wrap" title="选择连锁总部" :visible.sync="medDialog" :modal-append-to-body="false" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="12">
          <div class="search-area-div">连锁总部名称：</div>
          <el-input v-model="medQueryPage.customerName" class="ipt-sty" clearable placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button size="medium" type="info" @click="getMedList(1)">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="medList" style="width: 100%" :row-key="isEsQuery == 'N' ? 'guid' : 'commonGuid'" border
        v-loading="loading" ref="medTable" @row-click="handleClickMed" @select="handleSelectMed">
        <el-table-column type="selection" width="60" :reserve-selection="true"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (medQueryPage.pageIndex - 1) * medQueryPage.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="medName" label="连锁总部名称" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.customerName }}
          </template>
        </el-table-column>
        <el-table-column prop="venue" label="所在区域" header-align="center" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.commonGuid">{{ scope.row.provinceName }}{{ scope.row.cityName ? '/' + scope.row.cityName : ''
            }}{{ scope.row.districtName ? '/' + scope.row.districtName : '' }}</span>
            <span v-else>{{ scope.row.venue || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.address || '-' }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleMedSizeChange"
        @current-change="handleMedCurrentChange" :page-sizes="[10, 30, 50]" :current-page="medQueryPage.pageIndex"
        :page-size="medQueryPage.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="medQueryPage.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="medDialog = false">取消</el-button>
        <el-button size="medium" type="info" @click="medSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择连锁总部结束 -->
    <AuditDialog @closeAudit="closeAudit"></AuditDialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
import dialogMap from '../../components/dialogMap';
import recentDate from '@/uilt/recentDate';
import { removeDuplicates } from '@/uilt/tool';
import ChoosePerson from './components/ChoosePerson';
import AuditDialog from './components/AuditDialog';
import mixins from './components/mixins/detailMixins.js';
export default {
  components: {
    dialogMap,
    ChoosePerson,
    AuditDialog
  },
  mixins: [mixins],
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRowss: 0,
      },
      customerGuids: [],
      departmentList: [],
      // 树状
      areaData: [],
      defaultProps: {
        id: 'id',
        label: 'label',
        children: 'children',
      },
      tenantList: [],
      serviceTenants: [],
      serviceTenantGuid: '',
      dialogLoading: false,
      txt: '',
      dialogVisible: false,
      options: areaJson,
      fullscreenLoading: false,
      showChoosePerson: false, // 人员选择
      belongStaffList: [], // 指派人员列表
      changebelongStaffList: [], // 修改后的指派人员
      belongStaffs: [],
      ruleForm: {
        tenantGuid: '',
        customerName: '',
        // createUserId: '',
        terminalProperty: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        level: '', //客户等级
        chainHeadquartesGuid: '', //连锁总部Guid
        chainHeadquartesName: '', //连锁总部名称
        recordName: '', //备案名称
        directStoresNum: '', //直营门店数量
        affiliatedShopNum: '', //加盟门店数量
        markingPosition: '',
        venue: '',
        chainHeadquartersType: null, //连锁总部类型
        establishDate: null, //成立时间
        enterpriseNature: null, //企业性质
        industryStatus: null, //行业地位
        lawsuit: null, //司法官司
        bizState:'Y'
      },
      // 业务指派人员

      addressList: [],
      rules: {
        tenantGuid: [{ required: true, message: '请选择公司', trigger: 'blur' }],
        createUserId: [{ required: true, message: '请选择所属人员姓名', trigger: 'change' }],
        customerName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // contacts: [{ required: true, message: '请输入药店联系人', trigger: 'blur' }],
        // contactTel: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        // ],
        addressList: [
          {
            type: 'array',
            required: true,
            message: '请选择所属区域',
            trigger: 'change',
          },
        ],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        markers: [{ required: true, message: '请选择经纬度', trigger: 'blur' }],
        terminalProperty: [{ required: true, message: '请选择药店类型', trigger: 'change' }],
        inputDate: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      regionList: [
        {
          value: 'NE',
          name: '东北区',
        },
        {
          value: 'NC',
          name: '华北区',
        },
        {
          value: 'SC',
          name: '华南区',
        },
        {
          value: 'NW',
          name: '西北区',
        },
        {
          value: 'SW',
          name: '西南区',
        },
        {
          value: 'CC',
          name: '华中区',
        },
        {
          value: 'EC',
          name: '华东区',
        },
      ],
      customerTypeList: [
        {
          value: '单体药店',
          label: '单体药店',
        },
        {
          value: '连锁总部',
          label: '连锁总部',
        },
        {
          value: '连锁门店',
          label: '连锁门店',
        },
        {
          value: '诊所',
          label: '诊所',
        },
        {
          value: '乡镇卫生院（含村卫生室）',
          label: '乡镇卫生院（含村卫生室）',
        },
      ],
      joinKeyWords: '',
      staffList: [],
      customerLevelOption: [],
      chainHeadquartesOption: [], //连锁总部下拉
      customerSameDialog: false,
      commonCustomerList: [], //重复客户
      expireTimeOption: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      }, //时间限制当天以前可选
      type: {
        A: 'warning',
        Y: 'success',
        N: 'danger',
      },
      approveStateObj: {
        A: '待审批',
        Y: '合格',
        N: '不合格',
      },
      approveState:'',
      medQueryPage: {
        customerName: '',
        pageSize: 10,
        pageIndex: 1,
        tenantGuid: this.$store.state.guid,
      },
      medDialog: false,
      medList: [],
      currentMedSelect: [],
      currentMedSelectRow: {},
    };
  },
  computed: {},
  watch: {},

  created() {
    // this.getOrganisation();
    if (this.$route.query.guid) {
      this.txt = '编辑资料';
      this.getCustomerDetail(this.$route.query.guid, () => {
        this.showSalesman();
      });
    } else {
      this.reset();
      // this.getChainHeadquartes('');
      if (this.$route.query.tenantGuid) {
        this.getStaffList(this.$route.query.tenantGuid);
      }
    }
    if(this.$route.query.isAudit){
      this.approveState=this.$route.query.approveState||''
      this.rules.terminalProperty=[{ required: true, message: '请选择药店类型', trigger: 'blur' }]
    }
    if(this.$route.query.disabled){
      this.rules.terminalProperty=[{ required: true, message: '请选择药店类型', trigger: 'blur' }]
    }
    this.getTenantOperationRelList(false);
    
    this.areaData = [];
  },
  methods: {
    closeAudit(state){
      this.$router.go(-1)
      // this.approveState=state
      // this.$forceUpdate()
    },
    toAudit() {
      this.$root.$emit('auditDialog', {
        auditDialogVisible: true,
        title:'审批',
        // type,
        approveGuidList: [this.$route.query.approveGuid],
      });

    },
    // //获取组织
    // getOrganisation() {
    //   let self = this;
    //   let query = {
    //     tenantGuid: this.ruleForm.tenantGuid || this.$store.getters.getTenantGuid,
    //   }
    //   self.api
    //     .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`,query)
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.areaData = res.data.data;
    //         self.treeData(self.areaData);
    //         console.log(self.areaData);
    //       } else {
    //         self.$message.error(res.data.msg);
    //         self.areaData = [];
    //       }
    //     });
    // },
    // treeData(areaData) {
    //   var self = this;
    //   const fn = (tree) => {
    //     tree.forEach((k) => {
    //       k.label = `${k.organisationName}${k.mobileNo || ''}` || `${k.name}${k.mobileNo || ''}`;
    //       k.staffName = k.name;
    //       k.mobileNo = k.mobileNo;
    //       k.id = k.guid;
    //       k.staffGuid = k.guid;
    //       //下面数据是我自己加上的,发请求需要
    //       // k.mobileNo = k.mobileNo;
    //       // k.organisationNames = k.organisationNames;
    //       k.icon = require('../../assets/images/ico_ora.png');
    //       // 根据id获取人员数据,(注意转为树类型)
    //       if (k) {
    //         k.staffList = [];
    //         if (k.staffs) {
    //           k.staffs.forEach((d) => {
    //             let item = {
    //               usertype: 1,
    //               id: d.guid,
    //               staffGuid: d.guid,
    //               label: d.name + d.mobileNo,
    //               //下面数据是我自己加上的,发请求需要
    //               mobileNo: d.mobileNo,
    //               staffName: d.name,
    //               tenantGuid: d.tenantGuid,
    //               organisationNames: '123',
    //               positionName: '123',
    //               roleNames: '123',
    //               logonUser: '123',
    //               icon: require('../../assets/images/icon_per.png'),
    //             };
    //             k.staffList.push(item);
    //           });
    //         }
    //         const person = k.staffList;
    //         const isValid = (val) => {
    //           return val && val !== null && JSON.stringify(val) !== '[]';
    //         };
    //         // 将人员数据拼接到chilren里面
    //         if (k.children) {
    //           fn(k.children);
    //           isValid(person) && (k.children = [...k.children, ...person]);
    //           // 有子元素，需要调用自身
    //         } else {
    //           isValid(person) && (k.children = person);
    //         }
    //       }
    //     });
    //   };
    //   fn(areaData);
    // },
    //删除
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.id == j.id) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
    },
    // popupBox1() {
    //   this.areaData = [];
    //   if (!this.ruleForm.tenantGuid) {
    //     this.$message.error('请先选择公司');
    //     return;
    //   }
    //   this.showChoosePerson = true;
    //   this.getOrganisation();
    // },
    //获取配置下拉选项
    transform(list, type) {
      var newList = [];
      if (list && list.length > 0) {
        list.forEach((item) => {
          newList.push({
            label: item.text,
            value: item.value,
          });
        });
      }
      return newList;
    },
    //获取配置对应字段
    getFieldConfig(params, key) {
      var fieldList = JSON.parse(localStorage.getItem('TZYDJD_CONFIG')).fieldList;
      var newConfig = {};
      fieldList.forEach((item) => {
        if (item.fieldName == params) {
          newConfig = item;
        }
      });
      return newConfig && newConfig[key];
    },
    openMedDialog() {
      if (this.taskTitleAndTaskContentName == '' && this.taskList.length) {
        this.$message.error('请选择任务！');
        return;
      }
      this.medDialog = true;
      this.$nextTick(() => {
        this.$refs.medTable.clearSelection();
      });
      this.getMedList(1);
    },
    //获取连锁总部
    getMedList(val) {
      if (!this.ruleForm.tenantGuid) {
        return;
      }
      if (val) {
        this.medQueryPage.pageIndex = 1;
      }
      let query = {
        pageIndex: this.medQueryPage.pageIndex,
        tenantGuid:this.ruleForm.tenantGuid,
        pageSize: this.medQueryPage.pageSize,
        keyword: this.medQueryPage.customerName,
        customerType: '5',
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/customer/get-customer-es`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.chainHeadquartesOption = res.data.data.records || [];
          this.medList = res.data.data.records || [];
          this.medQueryPage.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleMedSizeChange(val) {
      this.medQueryPage.pageSize = val;
      this.getMedList();
    },
    handleMedCurrentChange(val) {
      this.medQueryPage.pageIndex = val;
      this.getMedList();
    },
    handleClickMed(row, col, event) {
      this.$refs.medTable.clearSelection();
      row.flag = !row.flag;
      this.$refs.medTable.toggleRowSelection(row, row.flag);
      this.currentMedSelectRow = row;
    },

    handleSelectMed(selection, row) {
      this.$refs.medTable.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.currentMedSelectRow = row;
        this.$refs.medTable.toggleRowSelection(row, true);
      }
    },
    medSure() {
      if (!this.currentMedSelectRow.commonGuid) {
        this.$message.error('请选择连锁总部！');
      } else {
        this.ruleForm.chainHeadquartesGuid = this.currentMedSelectRow.commonGuid;
        this.ruleForm.chainHeadquartesName = this.currentMedSelectRow.customerName;
        this.medDialog = false;
        this.medQueryPage.customerName=''
      }
    },
    tenantChange() {
      let self = this;
      self.ruleForm.chainHeadquartesGuid = null;
      self.ruleForm.chainHeadquartesName = null;
      self.ruleForm.createUserId = null;
      self.getStaffList(self.ruleForm.tenantGuid);
      self.checkCommonCustomer(self.ruleForm.customerName);
      // self.getChainHeadquartes('');
    },
    getStaffList(tenantGuid) {
      // if (!tenantGuid) {
      //   this.$message.error('请选择公司名称！');
      //   return;
      // }
      // this.api
      //   .get(`/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + tenantGuid)
      //   .then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.staffList = res.data.data;
      //     } else {
      //       this.$message.error(res.data.data.msg);
      //     }
      //   });
    },
    handleChange(value) {
      console.log(value);
    },
    showMap() {
      if (this.disabled) return;
      this.dialogVisible = true;
    },
    getMarkers(marker) {
      this.dialogVisible = false;
      this.ruleForm.markers = marker;
      this.ruleForm.addressList = [marker.province, marker.city, marker.district];
      this.ruleForm.address = marker.address;
      this.ruleForm.markingPosition = marker.address;
      // 程序化回填addressList不会触发票联change,需同步重算venue,否则提交的venue仍是旧区域
      let venue = '';
      if (marker.province) {
        venue = this.province(marker.province);
      }
      if (marker.city) {
        venue = this.province(marker.province) + '/' + this.city(marker.city);
      }
      if (marker.district) {
        venue = this.province(marker.province) + '/' + this.city(marker.city) + '/' + this.district(marker.district);
      }
      this.ruleForm.venue = venue;
      console.log('markermarker', marker);
    },
    close() {
      this.dialogVisible = false;
    },
    //检测客户名称是否重复
    checkCommonCustomer(name) {
      let self = this;
      if (this.checkName('customerName', this.ruleForm.customerName)) return;
      if (name) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(name)) {
          // 如果包含特殊字符返回false
          self.$message.error(
            `${self.ruleForm.terminalProperty == '连锁门店' ? '分店' : '药店'}名称仅可输入中文、英文、数字、括号、顿号!`,
          );
          return false;
        }
      } else {
        return;
      }
      // if (name && self.ruleForm.terminalProperty == '连锁门店' && (name.includes('连锁') || name.includes('药店'))) {
      //   self.$message.error(`分店名称不规范，不可包含“药店”二字`);
      //   self.ruleForm.customerName = null;
      //   return;
      // }
      // if (name && self.ruleForm.terminalProperty == '连锁总部' && !name.includes('连锁')) {
      //   self.$message.error(`连锁总部名称不规范，需包含“连锁”二字`);
      //   // self.ruleForm.customerName = null;
      //   return;
      // }
      this.existsCheckBlur('1')
      // self.api
      //   .get(
      //     `/${serverConfig.msCustomerService}/common/data/check-exists?customerName=${name}&customerType=1&tenantGuid=${guid}`,
      //   )
      //   .then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.commonCustomerList = res.data.data ? [res.data.data] : [];
      //       this.customerSameDialog = res.data.data ? true : false;
      //     } else {
      //       self.$message.error(res.data.msg);
      //     }
      //   });
    },
    checkName(key, value, formObj) {
      if (formObj) formObj[key] = this.$NameCheckBlur(this, value, key); // todo 姓名长度校验
      let errorKeyword = this.getFieldConfig(key, 'errorKeyword');
      let newArr = [];
      if (!errorKeyword || !value) return false;
      let errorKeywordList = errorKeyword.split('、');
      try {
        errorKeywordList.forEach((item) => {
          if (value.indexOf(item) > -1 && flag) {
            flag = false;
            newArr.push(item);
          }
        });
        throw new Error(newArr);
      } catch (e) {
        if (!newArr.length) return false;
        this.$message.error(`不可输入【${newArr.join('、')}】，请规范填写`);
        return true;
      }

    },
    getCustomerDetail(guid, callBack) {
      let self = this;
      self.staffDetail = '';
      self.defaultCheckedKeys = [];
      self.api
        .postJson(`/${serverConfig.msCustomerService}/customer/data/get-detail?` + `guid=` + this.$route.query.guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffDetail = res.data.data;
            console.log(self.staffDetail, '找数据');
            let marker = {
              lat: self.staffDetail.lat,
              lng: self.staffDetail.lng,
            };
            console.log(self.ruleForm.markers);
            let date = self.staffDetail.inputDate
              ? self.$moment(self.staffDetail.inputDate).format('YYYY-MM-DD')
              : null;
            this.ruleForm = {
              tenantGuid: self.staffDetail.tenantGuid,
              customerName: self.staffDetail.customerName,
              terminalProperty: self.staffDetail.terminalProperty,
              createUserId: self.staffDetail.createUserId,
              region: self.staffDetail.region,
              province: self.staffDetail.province,
              city: self.staffDetail.city,
              district: self.staffDetail.district,
              venue: self.staffDetail.venue,
              address: self.staffDetail.address,
              contacts: self.staffDetail.contacts,
              contactTel: self.staffDetail.contactTel,
              lng: self.staffDetail.lng,
              lat: self.staffDetail.lat,
              inputDate: date,
              addressList: [self.staffDetail.province, self.staffDetail.city, self.staffDetail.district],
              markers: marker,
              manageDuration: self.staffDetail.manageDuration,
              areaMeasure: self.staffDetail.areaMeasure,
              level: self.staffDetail.level, //客户等级
              chainHeadquartesGuid: self.staffDetail.chainHeadquartesGuid, //连锁总部
              chainHeadquartesName: self.staffDetail.chainHeadquartesName, //连锁总部
              recordName: self.staffDetail.recordName, //备案名称
              directStoresNum: self.staffDetail.directStoresNum, //直营门店数量
              affiliatedShopNum: self.staffDetail.affiliatedShopNum, //加盟门店数量
              markingPosition: self.staffDetail.markingPosition, //标注位置
              chainHeadquartersType: self.staffDetail.chainHeadquartersType, //连锁总部类型
              establishDate: self.staffDetail.establishDate
                ? self.$moment(self.staffDetail.establishDate).format('YYYY-MM-DD')
                : null, //成立时间
              enterpriseNature: self.staffDetail.enterpriseNature, //企业性质
              industryStatus: self.staffDetail.industryStatus, //行业地位
              lawsuit: self.staffDetail.lawsuit, //司法官司
              bizState: self.staffDetail.bizState, //启用状态
            };
            // self.getChainHeadquartes(self.ruleForm.chainHeadquartesName);
            self.getStaffList(self.ruleForm.tenantGuid);

            self.customerGuids.push(self.staffDetail.guid);
            //执行函数
            if (callBack) {
              callBack();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 负责人回显
    showSalesman(val) {
      console.log(val);
      let query = {
        customerGuids: this.customerGuids,
        pageIndex: this.page.pageIndex,
        // 要把列表所有数据获取到
        pageSize: 10000,
      };

      this.api.postJson(`/${serverConfig.msCustomerService}/customer/get-belong-staff`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.belongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
          this.changebelongStaffList = JSON.parse(JSON.stringify(res.data.data.records)) || [];
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    reset() {
      this.txt = '添加资料';
      this.ruleForm = {
        tenantGuid: '',
        customerName: '',
        // createUserId: '',
        terminalProperty: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        level: '', //客户等级
        chainHeadquartesGuid: '', //连锁总部Guid
        chainHeadquartesName: '', //连锁总部名称
        recordName: '', //备案名称
        directStoresNum: '', //直营门店数量
        affiliatedShopNum: '', //加盟门店数量
        markingPosition: '', //标注位置
        chainHeadquartersType: null, //连锁总部类型
        establishDate: null, //成立时间
        enterpriseNature: null, //企业性质
        industryStatus: null, //行业地位
        lawsuit: null, //司法官司
        bizState:'Y',//启用状态
      };
      this.belongStaffList =  [];
      this.changebelongStaffList = []
      if(this.$refs.refMap){
        this.$refs.refMap.locationSearch=null
        this.$refs.refMap.searchList=[]
        this.$refs.refMap.mapType= 'bdMap'
        this.$refs.refMap.changeMap('bdMap')
      }
      if(this.$refs.choosePerson){
        this.$refs.choosePerson.departmentList=[]
      }
    },
    incres(area) {
      // const checkedNodes = this.$refs['cascaderFirst'].getCheckedNodes();
      // let arr = checkedNodes[0].pathNodes;
      let codeArr = area;
      // arr.forEach((item) => {
      //   codeArr.push(item.data.value);
      // });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      let venue = '';
      if (codeArr) {
        if (codeArr[0]) {
          venue = this.province(codeArr[0]);
        }
        if (codeArr[1]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]);
        }
        if (codeArr[2]) {
          venue = this.province(codeArr[0]) + '/' + this.city(codeArr[1]) + '/' + this.district(codeArr[2]);
        }
      }
      this.ruleForm.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    //药店类型
    changeTerminalProperty(val) {
      if (val=='连锁门店'&& this.chainHeadquartesOption.length<1) {
        // this.getChainHeadquartes('')
      }
    },
    // changeChainHeadquartesName(val) {
    //   let self = this;
    //   if (val) {
    //     if (self.chainHeadquartesOption.length > 0) {
    //       self.chainHeadquartesOption.forEach((i) => {
    //         if (i.commonGuid == self.ruleForm.chainHeadquartesGuid) {
    //           self.ruleForm.chainHeadquartesName = i.customerName;
    //         }
    //       });
    //     }
    //   }
    // },
    submitForm(formName, flg) {
      let self = this;
      if (this.checkName('customerName', this.ruleForm.customerName)) return;
      if (this.checkName('contacts', this.ruleForm.contacts)) return;
      if (self.ruleForm.customerName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(self.ruleForm.customerName)) {
          // 如果包含特殊字符返回false
          self.$message.error('药店名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }
      }
      // if (this.ruleForm.contactTel) {
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      //   if (!regs.test(this.ruleForm.contactTel)) {
      //     this.$message.error('手机号格式不正确！');
      //     return;
      //   }
      // }
      // 连锁总部运营端非必填
      // if (
      //   !this.ruleForm.chainHeadquartesName &&
      //   this.getFieldConfig('chainHeadquartesName', 'formVisible') == 'Y' &&
      //   this.getFieldConfig('chainHeadquartesName', 'isRequired') == 'Y' &&
      //   this.ruleForm.terminalProperty == '连锁总部'
      // ) {
      //   this.$message.error(`${this.getFieldConfig('chainHeadquartesName', 'fieldAlias')}不能为空`);
      //   return;
      // }
      if (
        !this.ruleForm.chainHeadquartesName && this.ruleForm.chainHeadquartesGuid
      ) {
        this.ruleForm.chainHeadquartesGuid=''//清空连锁总部Guid
      }
      // 连锁总部类型
      if (
        !this.ruleForm.chainHeadquartersType &&
        this.getFieldConfig('chainHeadquartersType', 'formVisible') == 'Y' &&
        this.getFieldConfig('chainHeadquartersType', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('chainHeadquartersType', 'fieldAlias')}不能为空`);
        return;
      }
      // 备案名称
      if (
        !this.ruleForm.recordName &&
        this.getFieldConfig('recordName', 'formVisible') == 'Y' &&
        this.getFieldConfig('recordName', 'isRequired') == 'Y'
      ) {
        this.$message.error(`${this.getFieldConfig('recordName', 'fieldAlias')}不能为空`);
        return;
      }
      // 客户等级
      if (
        !this.ruleForm.level &&
        this.getFieldConfig('level', 'formVisible') == 'Y' &&
        this.getFieldConfig('level', 'isRequired') == 'Y'
      ) {
        this.$message.error(`${this.getFieldConfig('level', 'fieldAlias')}不能为空`);
        return;
      }
      // 成立时间
      if (
        !this.ruleForm.establishDate &&
        this.getFieldConfig('establishDate', 'formVisible') == 'Y' &&
        this.getFieldConfig('establishDate', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('establishDate', 'fieldAlias')}不能为空`);
        return;
      }
      // 企业性质
      if (
        !this.ruleForm.enterpriseNature &&
        this.getFieldConfig('enterpriseNature', 'formVisible') == 'Y' &&
        this.getFieldConfig('enterpriseNature', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('enterpriseNature', 'fieldAlias')}不能为空`);
        return;
      }
      // 行业地位
      if (
        !this.ruleForm.industryStatus &&
        this.getFieldConfig('industryStatus', 'formVisible') == 'Y' &&
        this.getFieldConfig('industryStatus', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('industryStatus', 'fieldAlias')}不能为空`);
        return;
      }
      // 司法官司
      if (
        !this.ruleForm.lawsuit &&
        this.getFieldConfig('lawsuit', 'formVisible') == 'Y' &&
        this.getFieldConfig('lawsuit', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('lawsuit', 'fieldAlias')}不能为空`);
        return;
      }
      if (this.$NameCheck(this, this.ruleForm.contacts, 'contacts')) {
        // todo 姓名长度校验
        return;
      }

      let createUserName = '';
      let staffGuid = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
            staffGuid = i.guid;
          }
        });
      }

      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            tenantGuid: self.ruleForm.tenantGuid,
            customerName: self.ruleForm.customerName,
            // createUserId: self.ruleForm.createUserId,
            createUserName: createUserName,
            staffGuid: staffGuid,
            terminalProperty: self.ruleForm.terminalProperty,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            venue: self.ruleForm.venue,
            contacts: self.ruleForm.contacts,
            contactTel: self.ruleForm.contactTel,
            lng: this.ruleForm.markers.lng,
            lat: this.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            areaMeasure: self.ruleForm.areaMeasure,
            manageDuration: self.ruleForm.manageDuration,
            level: self.ruleForm.level,
            bizState: self.ruleForm.bizState,
            chainHeadquartesGuid: self.ruleForm.chainHeadquartesGuid, //连锁总部Guid
            chainHeadquartesName: self.ruleForm.chainHeadquartesName, //连锁总部名称
            recordName: self.ruleForm.recordName, //备案名称
            directStoresNum: self.ruleForm.directStoresNum, //直营门店数量
            affiliatedShopNum: self.ruleForm.affiliatedShopNum, //加盟门店数量
            markingPosition: self.ruleForm.markingPosition, //标注位置
            chainHeadquartersType: self.ruleForm.chainHeadquartersType, //连锁总部类型
            establishDate: self.ruleForm.establishDate
              ? self.$moment(self.ruleForm.establishDate).format('YYYY-MM-DD')
              : null, //成立时间
            enterpriseNature: self.ruleForm.enterpriseNature, //企业性质
            industryStatus: self.ruleForm.industryStatus, //行业地位
            lawsuit: self.ruleForm.lawsuit, //司法官司
            serviceTenantGuid: localStorage.guid,
            belongStaffs: this.changebelongStaffList,
          };
          if (promise.terminalProperty == '连锁总部') {
            promise.areaMeasure = null;
            promise.manageDuration = null;
          } else {
            promise.directStoresNum = 0;
            promise.affiliatedShopNum = 0;
          }
          if (promise.terminalProperty !== '连锁门店') {
            promise.chainHeadquartesGuid = null;
            promise.chainHeadquartesName = null;
          }
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msCustomerService}/customer/data/pc-add`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              self.$refs[formName].resetFields();
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({
                  path: '/pharmacy',
                  query: { tenantGuid: self.$route.query.tenantGuid },
                });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName, flg) {
      console.log(formName, 33333);
      let self = this;
      if (this.checkName('customerName', this.ruleForm.customerName)) return;
      if (this.checkName('contacts', this.ruleForm.contacts)) return;
      if (self.ruleForm.customerName) {
        let patrn = /^[\u4e00-\u9fffA-Za-z0-9()（）、〇]+$/g;
        if (!patrn.test(self.ruleForm.customerName)) {
          // 如果包含特殊字符返回false
          self.$message.error('药店名称仅可输入中文、英文、数字、括号、顿号!');
          return;
        }
      }
      // if (self.ruleForm.contactTel) {
      //   let regs = /^((13[0-9])|(17[0-1,6-8])|(15[^4,\\D])|(18[0-9]))\d{8}$/;
      //   if (!regs.test(self.ruleForm.contactTel)) {
      //     self.$message.error('手机号格式不正确！');
      //     return;
      //   }
      // }
      // 连锁总部 运营端都为非必填
      // if (
      //   !this.ruleForm.chainHeadquartesName &&
      //   this.getFieldConfig('chainHeadquartesName', 'formVisible') == 'Y' &&
      //   this.getFieldConfig('chainHeadquartesName', 'isRequired') == 'Y'
      // ) {
      //   this.$message.error(`${this.getFieldConfig('chainHeadquartesName', 'fieldAlias')}不能为空`);
      //   return;
      // }
      if (
        !this.ruleForm.chainHeadquartesName && this.ruleForm.chainHeadquartesGuid
      ) {
        this.ruleForm.chainHeadquartesGuid=''//清空连锁总部Guid
      }
      // 连锁总部类型
      if (
        !this.ruleForm.chainHeadquartersType &&
        this.getFieldConfig('chainHeadquartersType', 'formVisible') == 'Y' &&
        this.getFieldConfig('chainHeadquartersType', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('chainHeadquartersType', 'fieldAlias')}不能为空`);
        return;
      }
      // 备案名称
      if (
        !this.ruleForm.recordName &&
        this.getFieldConfig('recordName', 'formVisible') == 'Y' &&
        this.getFieldConfig('recordName', 'isRequired') == 'Y'
      ) {
        this.$message.error(`${this.getFieldConfig('recordName', 'fieldAlias')}不能为空`);
        return;
      }
      // 客户等级
      if (
        !this.ruleForm.level &&
        this.getFieldConfig('level', 'formVisible') == 'Y' &&
        this.getFieldConfig('level', 'isRequired') == 'Y'
      ) {
        this.$message.error(`${this.getFieldConfig('level', 'fieldAlias')}不能为空`);
        return;
      }
      // 成立时间
      if (
        !this.ruleForm.establishDate &&
        this.getFieldConfig('establishDate', 'formVisible') == 'Y' &&
        this.getFieldConfig('establishDate', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('establishDate', 'fieldAlias')}不能为空`);
        return;
      }
      // 企业性质
      if (
        !this.ruleForm.enterpriseNature &&
        this.getFieldConfig('enterpriseNature', 'formVisible') == 'Y' &&
        this.getFieldConfig('enterpriseNature', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('enterpriseNature', 'fieldAlias')}不能为空`);
        return;
      }
      // 行业地位
      if (
        !this.ruleForm.industryStatus &&
        this.getFieldConfig('industryStatus', 'formVisible') == 'Y' &&
        this.getFieldConfig('industryStatus', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('industryStatus', 'fieldAlias')}不能为空`);
        return;
      }
      // 司法官司
      if (
        !this.ruleForm.lawsuit &&
        this.getFieldConfig('lawsuit', 'formVisible') == 'Y' &&
        this.getFieldConfig('lawsuit', 'isRequired') == 'Y' &&
        this.ruleForm.terminalProperty == '连锁总部'
      ) {
        this.$message.error(`${this.getFieldConfig('lawsuit', 'fieldAlias')}不能为空`);
        return;
      }
      let createUserName = '';
      let staffGuid = '';
      if (self.staffList) {
        self.staffList.forEach((i) => {
          if (i.userGuid == self.ruleForm.createUserId) {
            createUserName = i.staffName;
            staffGuid = i.guid;
          }
        });
      }
      // if (self.chainHeadquartesOption.length > 0) {
      //   self.chainHeadquartesOption.forEach((i) => {
      //     if (i.guid == self.ruleForm.chainHeadquartesGuid) {
      //       self.ruleForm.chainHeadquartesName = i.customerName;
      //     }
      //   });
      // }

      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.$route.query.guid,
            tenantGuid: self.ruleForm.tenantGuid,
            customerName: self.ruleForm.customerName,
            // createUserId: self.ruleForm.createUserId,
            createUserName: createUserName,
            staffGuid: staffGuid,
            terminalProperty: self.ruleForm.terminalProperty,
            province: self.ruleForm.addressList[0],
            city: self.ruleForm.addressList[1],
            district: self.ruleForm.addressList[2],
            address: self.ruleForm.address,
            venue: self.ruleForm.venue,
            contacts: self.ruleForm.contacts,
            contactTel: self.ruleForm.contactTel,
            lng: self.ruleForm.markers.lng,
            lat: self.ruleForm.markers.lat,
            inputDate: self.ruleForm.inputDate,
            areaMeasure: self.ruleForm.areaMeasure,
            manageDuration: self.ruleForm.manageDuration,
            level: self.ruleForm.level,
            bizState: self.ruleForm.bizState,
            directStoresNum: self.ruleForm.directStoresNum, //直营门店数量
            affiliatedShopNum: self.ruleForm.affiliatedShopNum, //加盟门店数量
            chainHeadquartesGuid: self.ruleForm.chainHeadquartesGuid, //连锁总部Guid
            chainHeadquartesName: self.ruleForm.chainHeadquartesName, //连锁总部名称
            recordName: self.ruleForm.recordName, //备案名称
            markingPosition: self.ruleForm.markingPosition, //标注位置
            chainHeadquartersType: self.ruleForm.chainHeadquartersType, //连锁总部类型
            establishDate: self.ruleForm.establishDate
              ? self.$moment(self.ruleForm.establishDate).format('YYYY-MM-DD')
              : null, //成立时间
            enterpriseNature: self.ruleForm.enterpriseNature, //企业性质
            industryStatus: self.ruleForm.industryStatus, //行业地位
            lawsuit: self.ruleForm.lawsuit, //司法官司
            serviceTenantGuid: localStorage.guid,
            belongStaffs: this.changebelongStaffList,
          };
          if (promise.terminalProperty == '连锁总部') {
            promise.areaMeasure = null;
            promise.manageDuration = null;
          } else {
            promise.directStoresNum = 0;
            promise.affiliatedShopNum = 0;
          }
          if (promise.terminalProperty !== '连锁门店') {
            promise.chainHeadquartesGuid = null;
            promise.chainHeadquartesName = null;
          }
          self.fullscreenLoading = true;
          self.api.put(`/${serverConfig.msCustomerService}/customer/data/pc-update`, promise).then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('提交成功');
              self.$refs[formName].resetFields();
              if (flg == 1) {
                self.reset();
              } else {
                self.$router.push({
                  path: '/pharmacy',
                  query: { tenantGuid: self.$route.query.tenantGuid },
                });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      let self = this;
      self.$router.push({
        path: '/pharmacy',
        query: { tenantGuid: self.$route.query.tenantGuid },
      });
    },
    /**
     * @param val 对应值
     * @param formObj 表单对象
     * @param fildeName 字段key
     */
    nameBlur(val, formObj, fildeName) {
      formObj[fildeName] = this.$NameCheckBlur(this, val, fildeName);
    },
    // 获取勾选的人员
    getPerson(res) {
      console.log(res);
      this.changebelongStaffList = res;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  // padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
    .approve-btn{
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
    .approve-tag{
      font-size: 12px;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      line-height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      right: 16px;
      top: 6px;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    .el-col-12 {
      margin-bottom: 12px;
    }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }

  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }

  .operte-btns .btn.save {
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
  }

  .operte-btns .btn.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
/deep/ .el-input__inner{
  height:40px;
  line-height:36px
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>
<style scoped>
.content-main-box {
  height: 100%;
  max-height: 300px;
}
.el-table .el-table__cell {
  padding: 0px;
}
.addPeople {
  width: 84px;
  height: 28px;
  margin-top: 5px;
  border: 1px solid #4fa1a4;
  text-align: center;
  line-height: 28px;
  color: #4fa1a4;
}
.mt20 .el-form-item__content {
  width: 830px;
}

.content {
  margin: 0px;
}
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.costApprove {
  text-align: left;
  background: #fff;
  margin: 16px;
  padding: 20px 30px;
  display: flow-root;
}

.cost-title {
  height: 72px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.cost-title .flow-name {
  color: #323233;
  font-size: 20px;
}
.cost-title .task-tips {
  margin-left: 20px;
}
.cost-title .flow-back {
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  padding: 0 26px;
  border: 1px solid #c8c9cd;
  cursor: pointer;
}
.cost-title-list {
  display: flex;
  align-items: center;
  height: 32px;
  line-height: 32px;
  padding-left: 20px;
  background: #f6f7fa;
}
.cost-title-list-line {
  display: inline-block;
  width: 6px;
  height: 14px;
  background: #4fa1a4;
}
.cost-title-list-txt {
  font-size: 18px;
  color: #323233;
  padding-left: 6px;
}
.cost-approve-list {
  display: flex;
  margin: 18px 0;
  position: relative;
  margin-bottom: 10px;
  width: 860px;
}
.cost-approve-list .tips {
  position: absolute;
  color: red;
  font-size: 12px;
  bottom: -6px;
  left: 145px;
}

.cost-approve-list-title {
  width: 145px;
  text-align: right;
  flex-shrink: 0;
  line-height: 40px;
  padding-left: 25px;
  box-sizing: border-box;
}
.cost-approve-list-content {
  flex: 1;
}
.cost-submit-btn {
  display: flex;
  justify-content: center;
  /* padding: 50px 0; */
  padding-bottom: 20px;
}
.cost-submit-btn-sure {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #4fa1a4;
  cursor: pointer;
  margin-left: 20px;
}
.cost-submit-btn-cancel {
  color: #fff;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #c8c9cc;
  cursor: pointer;
}
.cost-approve-list-content a {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  line-height: 40px;
}
.cost-header {
  display: flex;
  background: #f0f0f0;
  font-size: 12px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #dfdfdf;
}
.cost-header .header-child:last-child {
  border-right: 0 none;
}
.cost-wrap {
  border: 1px solid #dfdfdf;
  border-right: 0 none;
}
.cost-list-content {
  display: flex;
  border-bottom: 1px solid #dfdfdf;
}
.cost-list-content:last-child {
  border-bottom: 0 none;
}
.cost-list-content .header-child {
  flex: 1;
  padding: 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #dfdfdf;
}
.cost-list-content .add {
  color: #4fa1a4;
  cursor: pointer;
}
.cost-list-content .del {
  color: #d0021b;
  cursor: pointer;
}
.header-select span {
  margin-left: 6px;
}
.cost-row {
  display: flex;
}
.cost-row .cost-approve-list {
  width: 500px;
}
.cost-row-colum {
  width: 860px;
}
.cost-sub-title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding-left: 60px;
  margin-top: 10px;
}
.cost-sub-title .line {
  width: 860px;
  height: 1px;
  background: #dadada;
  margin-left: 20px;
}
.margin100 {
  margin-left: 60px;
}
.map-a-sty {
  width: 90px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #4fa1a4;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-dialog__footer {
  padding: 0px 20px 20px;
  text-align: right;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.header-sty {
  width: 100%;
  height: 65px;
  line-height: 65px;
}
.txt-sty {
  color: #323233;
  font-size: 20px;
  float: left;
  width: 90%;
  text-align: center;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
</style>
<style>
.reimbursement-check /deep/.el-checkbox__label {
  display: none !important;
}
</style>
